import React, { useRef, useLayoutEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import MiniCountdown from './MiniCountdown';
import heroImg from '../img/hero.jpg';

gsap.registerPlugin(ScrollTrigger);

const HeroPreview = ({ data }) => {
    const containerRef = useRef(null);

    useLayoutEffect(() => {
        let ctx = gsap.context(() => {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: "top 80%", // Content visible when card is mostly in view
                    toggleActions: "play none none reverse"
                }
            });

            tl.fromTo(".hero-title",
                { autoAlpha: 0, y: 24, filter: "blur(8px)" },
                { autoAlpha: 1, y: 0, filter: "blur(0px)", duration: 1.4, ease: "power3.out" }
            )
                .fromTo(".hero-sub",
                    { autoAlpha: 0, y: 18, filter: "blur(8px)" },
                    { autoAlpha: 1, y: 0, filter: "blur(0px)", duration: 1, ease: "power3.out" },
                    "-=0.6"
                )
                .fromTo(".hero-count",
                    { autoAlpha: 0, y: 14 },
                    { autoAlpha: 1, y: 0, duration: 0.8, ease: "power3.out" },
                    "-=0.6"
                );

        }, containerRef);

        return () => ctx.revert();
    }, []);

    return (
        <div ref={containerRef} className="absolute inset-0 z-0 overflow-hidden rounded-2xl">
            <div
                className="absolute inset-0 bg-cover bg-[center_30%] transform group-hover:scale-105 transition-transform duration-[3s] ease-out"
                style={{ backgroundImage: `url(${heroImg})` }}
            />
            <div className="absolute inset-0 bg-slate-900/40 group-hover:bg-slate-900/30 transition-colors duration-500" />
            <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-6 z-10">
                <h3 className="hero-title text-3xl md:text-6xl font-serif mb-4 drop-shadow-lg text-white">{data.title}</h3>
                <p className="hero-sub text-xs uppercase tracking-[0.3em] mb-6 text-white/90 font-medium">{data.date}</p>
                <div className="hero-count"><MiniCountdown /></div>
            </div>
        </div>
    );
};

export const HeroOverlay = ({ data }) => (
    <div className="flex flex-col h-full text-center md:text-left">
        <span className="text-lime-600 font-bold tracking-widest uppercase text-[10px] mb-3 block">Dettagli</span>
        <h3 className="text-3xl font-serif text-slate-800 mb-4">{data.overlayTitle}</h3>
        <p className="text-slate-600 text-sm leading-relaxed font-light mb-8">
            {data.description}
        </p>

        <ul className="space-y-3 mb-8 text-left bg-slate-50 p-6 rounded-xl border border-slate-100">
            {data.bullets && data.bullets.map((bullet, i) => (
                <li key={i} className="flex items-start gap-3">
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-lime-500 shrink-0" />
                    <span className="text-slate-700 text-sm font-medium">{bullet}</span>
                </li>
            ))}
        </ul>

        {data.techNote && (
            <div className="mt-auto pt-4 border-t border-slate-100">
                <code className="text-[10px] font-mono text-slate-400 block mb-1">TECH STACK</code>
                <code className="text-xs font-mono text-lime-700">{data.techNote}</code>
            </div>
        )}
    </div>
);

export default HeroPreview;
